module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_ali_2.082c3d5e.jpg";